import { ProductData } from "../5874/types";
import {
	SearchClientConfig,
	SearchRequest,
	SearchResults,
	SearchSuggestionsRequest,
	SearchSuggestionResults,
	SearchMerchandisingBanner,
	SearchFacet,
	RecommendationsRequest,
	SortByOptions,
	SearchSortByOptions,
} from "./types";

export default class SearchClient {
	protected config: SearchClientConfig;

	constructor(config: SearchClientConfig) {
		this.validateConfig(config);
		this.config = config;
	}

	public getConfig() {
		return this.config;
	}

	private validateConfig = (config: SearchClientConfig) => {
		switch (config.type) {
			case "algolia":
				if (!config.appId || !config.apiKey) {
					throw new Error("Algolia appId and apiKey are required");
				}
				break;
			case "searchspring":
				if (!config.siteId) {
					throw new Error("SearchSpring siteId is required");
				}
				break;
		}
	};

	getSortBy(): {
		options: Record<string, { label: string; value: string }>;
		default: string;
	} {
		return {
			options: {},
			default: "",
		};
	}

	protected createSortBy = (
		request: SearchRequest,
		sortByOptions: SortByOptions,
	): SearchSortByOptions => {
		const activeSort = request.sortBy || "default";

		return Object.entries(sortByOptions).reduce((acc, [key, value]) => {
			const options = {
				...value,
				isActive: key === activeSort,
				isDefault: key === "default",
			};

			acc[key] = options;

			return acc;
		}, {} as SearchSortByOptions);
	};

	/**
	 * Returns an empty response
	 * @returns SearchResults
	 */
	protected emptyResponse(sortByOptions?: SortByOptions): SearchResults {
		return {
			products: [] as ProductData[],
			merchandising: {
				banners: [] as SearchMerchandisingBanner[],
				redirect: undefined,
			},
			meta: {
				facets: [] as SearchFacet[],
				pagination: {
					page: 0,
					total: 0,
				},
				count: {
					from: 0,
					to: 0,
					total: 0,
				},
				sortBy: sortByOptions ?? {},
			},
			tracking: {
				queryId: "",
			},
			raw: {
				queryID: "",
			},
		} as SearchResults;
	}

	public async search(
		request: SearchRequest,
	): Promise<[SearchResults, () => Promise<ProductData[]>]> {
		return [this.emptyResponse(), () => Promise.resolve([])];
	}

	public async getSearchSuggestions(
		request: SearchSuggestionsRequest,
	): Promise<SearchSuggestionResults> {
		throw new Error("Not implemented");
	}

	public async getRecommendations(
		request: RecommendationsRequest,
	): Promise<[SearchResults, () => Promise<ProductData[]>]> {
		throw new Error("Not implemented");
	}
}
